window.addEventListener('load', function() {
  let addThisIcon = document.querySelector('.addthis_inline_share_toolbox');
  if (addThisIcon) {
    let observer = new MutationObserver(function() {
      if (document.querySelector('.at-icon-addthis')) {
        let plusIcon   = document.querySelector('.at-icon-addthis');
        let plusIconBG = document.querySelector('.at-svc-compact');
        plusIconBG.style.backgroundColor = '#fff';
        plusIcon.style.transform = 'scale(1.7)';
        plusIcon.style.fill = 'rgba(84, 84, 84, 1)';
      }
    });
    observer.observe(addThisIcon, {
      attributes: false, childList: true, characterData: false
    });    
  }
});
